import { Box } from "@mantine/core";
import { MotionConfig } from "framer-motion";
import { Navbar } from "./components/Navbar";
import { HeroSection } from "./components/HeroSection";
import { SocialProofBar } from "./components/SocialProofBar";
import { JewelSection } from "./components/JewelSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { UseCasesSection } from "./components/UseCasesSection";
import { SecurityBadgesSection } from "./components/SecurityBadgesSection";
import { PricingSection } from "./components/PricingSection";
import { FAQSection } from "./components/FAQSection";
import { CTASection } from "./components/CTASection";
import { Footer } from "./components/Footer";
import { TermsPage } from "./pages/TermsPage";
import { PrivacyPage } from "./pages/PrivacyPage";

function App() {
  // No router dependency: the production container serves with SPA fallback
  // (`serve -s`), so every path lands here and this switch picks the page.
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  if (path === "/terms") return <TermsPage />;
  if (path === "/privacy") return <PrivacyPage />;

  return (
    // reducedMotion="user" makes every framer-motion animation respect the
    // OS-level prefers-reduced-motion setting.
    <MotionConfig reducedMotion="user">
      <Box
        style={{
          minHeight: "100vh",
          scrollBehavior: "smooth",
        }}
      >
        <Navbar />
        <HeroSection />
        <SocialProofBar />
        {/* Product Tour and Benefits used to sit either side of Features.
            Both were pure restatement — the tour's four cards were a subset of
            Features, and all four Benefits cards repeated Jewel, Features or
            the security section below. */}
        <JewelSection />
        <FeaturesSection />
        <UseCasesSection />
        <SecurityBadgesSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </Box>
    </MotionConfig>
  );
}

export default App;
